import { apiClient } from "@/lib/api-client";

export const getIku1 = async (
  niu: string,
  year: string | number,
  semester: string | number,
  periodeID: string | number,
  month?: string | null,
) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const params = new URLSearchParams({
    year: String(year),
    semester: String(semester),
    periodeID: String(periodeID),
  });
  if (month) {
    params.append("month", month);
  }
  const response = await apiClient<any>(
    `${baseUrl}/api/v1/unsur-iku-1/${niu}?${params.toString()}`,
  );

  return response?.datas;
};
